<!-- =========================================================================================
    File Name: Invoice.vue
    Description: Invoice Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="transactions-quota" v-if="mounted">

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/2 w-full">
                <span>
                    Quantitée
                </span>
      </div>
      <div class="vx-col sm:w-1/2 w-full inline-flex" v-bind:class="{ 'text-danger': remainingVolume < 0 }">
        <span>{{remainingVolume}} {{cityConfig.volumeUnit}}<sup>3</sup></span>
      </div>
    </div>


    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/2 w-full">
                <span>
                  Visites:
                </span>
      </div>
      <div class="vx-col sm:w-1/2 w-full inline-flex">
        {{remainingVisits}}
      </div>
    </div>

  </div>
</template>

<script>
  import VueSlider from 'vue-slider-component'
  import 'vue-slider-component/theme/antd.css'
  import firebase from 'firebase'
  import moment from 'moment'
  import Vue from 'vue'

  Vue.filter('formatDate', function (value) {
    if (value)
    {
      return moment(value).format('YYYY-MM-DD HH:mm')
    }
  })

  export default {
    components: {
      VueSlider
    },
    props:      {
      clientID:         String,
      materialsAmounts: {
        type:    Array,
        default: () => []
      },
    },
    data ()
    {
      return {
        mounted: false,

        remainingVolume: '',
        remainingVisits: '',

        clientTransactions: [],
      }
    },
    computed:   {
      activeUserInfo ()
      {
        return this.$store.state.AppActiveUser
      },
      cityConfig ()
      {
        return this.$store.state.cityConfig
      },

    },
    methods:    {
      init ()
      {
        if (!this.cityConfig || !this.cityConfig.id)
        {
          return
        }

        this.remainingVisits = this.cityConfig.quotaVisits
        this.remainingVolume = this.cityConfig.quotaVolume

        this.fetchClientTransactions()

        this.mounted = true
      },
      currentQuotaUsed ()
      {
        let usedVolume = 0
        let usedVisits = 0
        const START_OF_YEAR = moment().startOf('year').toDate()

        this.clientTransactions.forEach(transaction => {
          let hasQuota = false

          if (transaction.createdAt.toDate() < START_OF_YEAR)
          {
            return
          }

          transaction.materials.forEach(material => {

            const result = this.cityConfig.quotaMaterials.find(obj => {
              return obj.name === material.name
            })

            if (result && result.quota && Math.abs(material.value) > 0.01)
            {
              hasQuota = true
              usedVolume += material.value
            }
          }) // materials

          if (hasQuota)
          {
            usedVisits++
          }
        }) // transactions


        let useVisitQuota = false
        this.materialsAmounts.forEach(material => {
          if (material.quota && Math.abs(material.value) > 0.01)
          {
            usedVolume += material.value
            useVisitQuota = true
          }
        })

        if (useVisitQuota)
        {
          usedVisits++
        }

        return [usedVisits, usedVolume]
      },
      fetchClientTransactions ()
      {
        this.clientTransactions = []

        if (!this.clientID)
        {
          this.updateQuota()
          return
        }

        firebase
          .firestore()
          .collection('transactions')
          .where('clientID', '==', this.clientID)
          .where('cityID', '==', this.cityConfig.id)
          .get()
          .then(results => {
            results.forEach(result => {
              const data = result.data()
              data.id    = result.id

              this.clientTransactions.push(data)
            })

            this.updateQuota()
          })

      },
      updateQuota ()
      {
        const [usedVisits, usedVolume] = this.currentQuotaUsed()

        this.remainingVisits = this.cityConfig.quotaVisits - usedVisits
        this.remainingVolume = this.cityConfig.quotaVolume - usedVolume
      },
    },
    watch:      {
      '$store.state.cityConfig' ()
      {
        this.init()
      },
      cityConfig ()
      {
        console.log('New Transaction: Updated city info')
        this.init()
      },
      clientID ()
      {
        console.log('Quota:  Client ID')

        this.fetchClientTransactions()
      },
      materialsAmounts: {
        deep: true,
        handler ()
        {
          console.log('Quota:  material Amounts')

          this.updateQuota()
        }
      }
    },
    mounted ()
    {
      console.log('New Transaction: monuted')

      this.init()
    }
  }
</script>

<style lang="scss">
  .vs-dialog {
    max-width: 80% !important;
  }
</style>
